/*
 * MIT License
 * Copyright (c) 2020 Excellens
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import * as Elementary from '@excellens/elementary'
import {FindOne} from "./Base";

export function Theme(document, id) {
    const self = {};

    this.id = id;

    this.template = null;

    this.initialize = function (control) {
        this.initializeTemplate();

        control.innerHTML = this.template;

        const id = this.id;
        control.classList.add(`theme-${id}`);

        return this;
    };

    this.initializeTemplate = function () {
        const id = this.id;

        const templateElement = FindOne(document, `script[type="theme/markdown-notepad"]#${id}`);
        this.template = templateElement.innerHTML;

        return this;
    };

    this.destroy = function () {
        this.template = null;

        return this;
    };

    return Elementary.Base.Merge(this, self);
}
